export class PromiseQueue<T = any> {
  private queue: Promise<any> = Promise.resolve(true);

  add(operation: () => Promise<T>) {
    return new Promise((resolve, reject) => {
      this.queue = this.queue
        .then(operation)
        .then(resolve)
        .catch(reject)
    })
  }
}